/**
 * Deep links into the Settings page (`/settings/configuration`) for things
 * that used to be pages of their own. One definition, so the redirects from
 * the old URLs and every in-app link agree.
 */

/** Settings → Printing → Printers (was /settings/printers). */
export const PRINTERS_SETTINGS_HREF =
  '/settings/configuration?tab=printing&section=printers';

/** Settings → Printing → Defaults (This Device, then each warehouse's). */
export const PRINTER_DEFAULTS_SETTINGS_HREF =
  '/settings/configuration?tab=printing&section=defaults';

/** Settings → Allocation (was /settings/allocation). */
export const ALLOCATION_SETTINGS_HREF =
  '/settings/configuration?tab=allocation';
